module.exports = __webpack_public_path__ + "bf4f70d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/p_serial/filterCourse/down.png
// module id = 1215
// module chunks = 5